import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ArrowDown from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/16x16/ArrowUp';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './CollapsibleDetailsBlock.scss';
var CollapsibleDetailsBlock = function (_a) {
    var deviationId = _a.deviationId, icon = _a.icon, title = _a.title, items = _a.items;
    var _b = useState(true), collapsed = _b[0], setCollapsed = _b[1];
    var buttonId = useUniqueId();
    var contentId = useUniqueId();
    var isCollapsible = items.length > 1;
    // When deviation changes (think duperbrowse), collapse again
    useEffect(function () {
        setCollapsed(true);
    }, [deviationId]);
    if (items.length < 1) {
        return null;
    }
    return (React.createElement("div", { className: cn(s['root'], collapsed && s['collapsed']) },
        React.createElement("div", { className: s['layout'] },
            isCollapsible ? (React.createElement(PlainButtonOrLink, { id: buttonId, className: s['toggle'], onClick: function () { return setCollapsed(!collapsed); }, "aria-controls": contentId, "aria-expanded": !collapsed },
                React.createElement("div", { className: s['icon'] }, icon),
                React.createElement("div", { className: s['title'] }, title),
                collapsed ? (React.createElement(ArrowDown, { size: IconSize.SMALL })) : (React.createElement(ArrowUp, { size: IconSize.SMALL })))) : (React.createElement("div", { className: s['header'] },
                React.createElement("div", { className: s['icon'] }, icon),
                React.createElement("div", { className: s['title'] }, title),
                React.createElement("div", { className: s['item-value'] }, items[0].value))),
            isCollapsible && (React.createElement("div", { className: s['content'], id: contentId, "aria-labelledby": buttonId }, items.map(function (_a, idx) {
                var label = _a.label, value = _a.value;
                return (React.createElement("div", { key: "item-".concat(idx), className: s['item'] },
                    React.createElement("div", { className: s['item-label'] }, label),
                    React.createElement("div", { className: s['item-value'] }, value)));
            }))))));
};
CollapsibleDetailsBlock.displayName = 'CollapsibleDetailsBlock';
export default CollapsibleDetailsBlock;
//# sourceMappingURL=CollapsibleDetailsBlock.js.map